/**
 * Clean the token query param from the URL.
 * The Go SPA handler already extracted ?token= and set the httpOnly cookie,
 * then redirected to strip it. This is a safety net in case the redirect
 * didn't happen (e.g., direct client-side navigation).
 */
export function cleanTokenFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  if (params.has('token')) {
    params.delete('token');
    const cleanSearch = params.toString();
    const cleanUrl =
      window.location.pathname + (cleanSearch ? `?${cleanSearch}` : '') + window.location.hash;
    window.history.replaceState(null, '', cleanUrl);
  }
}
